<template>
  <v-select
    v-model="internalValue"
    :items="items"
    :placeholder="placeholder"
    outlined
    flat
    dense
    :disabled="disabled"
    :error-messages="errors"
    :hide-details="!errors || errors.length === 0"
    item-value="value"
    item-text="text"
    class="modern-input-field"
    @input="updateValue"
    @change="change"
    return-object
  >
    <template v-slot:selection="{ item }">
      <span class="lato-font slate-text">{{ item.text }}</span>
    </template>
  </v-select>
</template>

<script>
import tipoActivity from '@/utils/tipoActivity.js'

export default {
  name: 'TipoActivitySelection',
  props: {
    value: {
      type: [Object, String],
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      items: [],
      internalValue: null
    }
  },
  computed: {
    placeholder() {
      return this.filtro ? 'Todos los tipos' : 'Seleccione un tipo'
    }
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val ? val.value : '')
    },
    change(val) {
      this.$emit('change', val ? val.value : '')
    },
    setInternalValue() {
      const searchVal = typeof this.value === 'string' ? this.value : (this.value ? this.value.value : '')
      this.internalValue = this.items.find(i => i.value === searchVal) || (this.filtro ? this.items[0] : null)
    }
  },
  mounted() {
    if (this.filtro) {
      this.items = [{ text: 'Todos', value: '' }, ...tipoActivity]
    } else {
      this.items = tipoActivity
    }
    this.setInternalValue()
  },
  watch: {
    value() {
      this.setInternalValue()
    }
  }
}
</script>

<style lang="scss" scoped>
.slate-text { color: #1A1F2E; }
.lato-font { font-family: 'Lato', sans-serif !important; }

.modern-input-field {
  ::v-deep .v-input__control {
    .v-input__slot {
      border-radius: 8px !important;
      background-color: #F8FAFC !important;
      border: 1px solid #E2E8F0 !important;
      box-shadow: none !important;
      transition: all 0.2s ease;
      
      fieldset { border: none; }
    }
    
    &.v-input--is-focused .v-input__slot {
      background-color: #FFFFFF !important;
      border-color: #35BDC8 !important;
      box-shadow: 0 0 0 4px rgba(53, 189, 200, 0.08) !important;
    }
    
    .v-label {
      font-size: 0.9rem;
      color: #94A3B8 !important;
    }
  }
}
</style>